/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Splits_DescInputs */

const en_ui_laps_splits_desc = /** @type {(inputs: Ui_Laps_Splits_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equal distance`)
};

const de_ui_laps_splits_desc = /** @type {(inputs: Ui_Laps_Splits_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleiche Distanz`)
};

/**
* | output |
* | --- |
* | "Equal distance" |
*
* @param {Ui_Laps_Splits_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_splits_desc = /** @type {((inputs?: Ui_Laps_Splits_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Splits_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_splits_desc(inputs)
	return de_ui_laps_splits_desc(inputs)
});